import styled from 'styled-components'
import { Button } from 'antd'

const TimeButton = styled(Button)`
	width: 100%;
`

export default { TimeButton }
